module.exports = __webpack_public_path__ + "static/oesWelfare.34025493.png";